'use es6';

import { useSelector } from 'react-redux';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { trackEvent, EVENTS } from '../lib/usageTracker';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { LOADING } from 'reporting-action-components/reportingActions/problems';
import useCreateNewReportProblem from 'reporting-action-components/reportingActions/shared/problemHooks/useCreateNewReportProblem';
import { getHasCustomReportingAccess, getIsUngatedToReportSetup } from '../selectors/gatesSelector';
import { jsx as _jsx } from "react/jsx-runtime";
const ReportLibraryButton = () => {
  const {
    problem,
    disabledMessage
  } = useCreateNewReportProblem();
  const isUngatedToReportSetup = useSelector(getIsUngatedToReportSetup);
  const hasCustomReportingAccess = useSelector(getHasCustomReportingAccess);
  const getButtonUrl = () => {
    if (isUngatedToReportSetup && hasCustomReportingAccess) {
      return `/discover/${PortalIdParser.get()}/create/reports/builders`;
    }
    return `/discover/${PortalIdParser.get()}/create/reports`;
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    title: disabledMessage,
    disabled: !problem,
    children: /*#__PURE__*/_jsx(Button, {
      href: getButtonUrl(),
      onClick: () => trackEvent(EVENTS.clickLibraryButton),
      disabled: !!problem,
      size: "sm",
      use: 'primary',
      "data-test-id": problem !== LOADING && 'discover-reports-action-button',
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'reports.header.discoverReports'
      })
    })
  });
};
export default ReportLibraryButton;